import axios from "axios";

import { ManagerVendorInfo } from "utils/types";

const apiInstance = axios.create({
  baseURL: window.__env__.API_BASE_URL,
  timeout: 20000,
});

/** Request interceptor for
 * - Adding the `Authorization` header in every non-auth url
 */
export const createRequestInterceptor = (
  accessToken: string,
  selectedVendor: ManagerVendorInfo | undefined,
  lang: string
) => {
  return apiInstance.interceptors.request.use((config) => {
    /** Add Authorization header and language*/
    if (config.headers) {
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
      config.headers["accept-language"] = lang;
    }

    if (selectedVendor) {
      config.params = {
        ...config.params,
        vendor_id: selectedVendor.id,
        vendor_type: selectedVendor.type,
      };
    }

    return config;
  });
};

/** Response interceptor for
 * - Getting the data from success response
 * - Logging out if response status is 401 UNAUTHORIZED
 * - Rejecting the error response
 */
export const createResponseInterceptor = (
  removeAuthData: () => void,
  mutations: number
) => {
  const UNAUTHORIZED = 401;

  return apiInstance.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (mutations === 0 && error.response?.status === UNAUTHORIZED) {
        removeAuthData();
      }
      return Promise.reject(error.response);
    }
  );
};

/** Response interceptor without store for nock testing **/
export const createResponseInterceptorTest = () => {
  return apiInstance.interceptors.response.use((response) => {
    return response.data;
  });
};

/** Eject both request and response interceptors */
export const ejectInterceptors = (
  reqInterceptor: number,
  resInterceptor: number
) => {
  apiInstance.interceptors.request.eject(reqInterceptor);
  apiInstance.interceptors.response.eject(resInterceptor);
};
export default apiInstance;
